require('magnific-popup');

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue3-cookies'

export const app = createApp(App)
    .use(store)
    .use(router)
    .use(VueCookies)

app.mount('#app')

router.app = app